import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BannersFirstDeferral } from './guards/banners-first-deferral';
import { ErrorStatusComponent } from '../shared/components/error-status/error-status.component';

export const routes: Routes = [

  {
    path: 'verification',
    redirectTo: '/account/verification',
  },
  {
    path: 'first-deferral',
    canActivate: [BannersFirstDeferral],
    component: ErrorStatusComponent,
  },

];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class BannersRoutingModule {
}
